import React, { useEffect, useState } from "react";
import { TermService } from "../../../../service/user_management/terms_conditions.service";
import Container from "@mui/material/Container";
import ContentWrapper from "../../../../components/common/ContentWrapper";
import Card from "../../../../components/common/Card";
import Footer from "../../../../components/admin/layouts/Footer";

import LinearProgress from "@mui/material/LinearProgress";
import { history } from "../../../../helper/history";
import { CombankService } from "../../../../service/manage/subscription/combank_pg.service.js";
import { StudentService } from "../../../../service/manage/registration/student.service.js";
import { sweetStatusAlert } from "../../../../components/common/SweetAlert.js";
import CircularProgress from '@mui/material/CircularProgress';

function PaymentTermsCondition() {
   
  const [termsHtml, setTermsHtml] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isChecked, setIsChecked] = useState(false);


  useEffect(() => {
    loadTermsAndCondition();
  }, []);

  const loadTermsAndCondition = async () => {
    setIsLoading(true);
    setError(null);
    const storedMedium = parseInt(sessionStorage.getItem("studentMedium"), 10);
   
    const studentMedium =
      Number.isInteger(storedMedium) && storedMedium > 0 ? storedMedium : 1;

    try {
      const res = await TermService.PaymentTermsById(studentMedium);
      if (res?.data?.content) {
        setTermsHtml(res.data.content);
      } else {
        setError("No terms available for the selected language.");
      }
    } catch (err) {
      console.error("Failed to load terms", err);
      setError("Failed to load terms. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const [isSpinnerLoading, setIsSpinnerLoading] = useState(false);

  const handleAccept = async () => {
    setIsSpinnerLoading(true);
    const creditPurches = sessionStorage.getItem('creditPurches');

     if (creditPurches && creditPurches == 'true') {
      
       sessionStorage.removeItem('creditPurches');

      // Check if this is a cart purchase
      let cartPending = null;
      try {
        cartPending = JSON.parse(sessionStorage.getItem('pendingCartPurchase') || 'null');
      } catch (e) {
        cartPending = null;
      }

      if (cartPending && cartPending.cart_payment_obj) {
        // Cart Purchase Flow
        try {
          await handleCartPaymentSubmit(cartPending.cart_payment_obj);
        } finally {
          setIsSpinnerLoading(false);
        }
      } else {
        // Single Package Purchase Flow
        try {
          window.dispatchEvent(new Event('creditPaymentAccepted'));
        } finally {
          sessionStorage.removeItem('creditPurches');
          setIsSpinnerLoading(false);
        }
      }
    } else   {
      
      try {
        await handleEnrollment();
        // window.dispatchEvent(new Event('payment_terms_accepted'));
      } finally {
        setIsSpinnerLoading(false);
      }
    }
  }
                                                   
  //Cart item purchase      

  const handleCartPaymentSubmit = async (cart_payment_obj) => {
    try {
      // Add popstate listener for back button cancel
      window.addEventListener('popstate', handlePaymentCancelNavigation);

      const res = await CombankService.getSessionIDCartPurchase(JSON.stringify(cart_payment_obj));
      const session_id = res?.data?.session?.id;

      sessionStorage.setItem('checkout_session_id', session_id);
      // Remove pending data (payment flow initiated)
      try { sessionStorage.removeItem('pendingCartPurchase'); } catch (e) { /* ignore */ }

      setIsSpinnerLoading(false);
      loadCheckoutScript(session_id);
    } catch (error) {
      sweetStatusAlert("Error!", "An error occurred while getting session ID.", "error");
      setIsSpinnerLoading(false);
    }
  };

  //   ***************************************  //                                       
  //   -----Enrollment paper buy------         ////
  //  ****************************************  //        


  const handleEnrollment = async () => {
      const session_id = sessionStorage.getItem("manage_user_id");

      // Read pending from sessionStorage, fallback to localStorage or history.state
      let pending = {};
      try {
        pending = JSON.parse(sessionStorage.getItem('pendingAssessmentCreditEnrollment') ||  '{}');
      } catch (e) {
        pending = {};
      }

      // Try route state as a last resort (history was used when navigating)
      if (!pending || Object.keys(pending).length === 0) {
        const historyPending = history && history.location && history.location.state && history.location.state.pendingAssessmentCreditEnrollment;
        if (historyPending) pending = historyPending;
      }

      // Validate pending
      if (!pending || !pending.asses_id) {
        sweetStatusAlert("Error!", "No pending payment/enrollment found. Please try again.", "error");
        setIsSpinnerLoading(false);
        return;
      }

      let enrollType = "user";
      setIsSpinnerLoading(true);

      // Decide enrollType for student
      if (pending.userType === "student") {
        try {
          const response = await StudentService.getreference(session_id);
          if (!(response.data.reference_id && response.data.has_parent)) {
            enrollType = "student";
          }
        } catch (e) {
          // ignore and proceed
        }
      }

      await handleAssessmentCreditSubmit(
        pending.asses_id,
        pending.no_of_credits,
        pending.amount,
        enrollType,
        pending.currencySymbol,
        pending.currencyId,
        pending.currencyName,
        pending
      );
    };

    const handleAssessmentCreditSubmit = async (assessment_id, no_of_credits, amount, enrollType, currencySymbol, currencyId, currencyName, pending = {}) => {
      const mid = 100;
      const session_id = sessionStorage.getItem("manage_user_id");
      const UserId = sessionStorage.getItem("manage_user_id");
      const table_log_id = sessionStorage.getItem("table_log_id");

      // Use pending fields as fallback in case component state was lost during navigation
      const userType = pending.userType || null;
      const assess_name = pending.assess_name || null;
      const selectedStudent = pending.selectedStudent || null;

      // Resolve student object (either object passed in pending or find in list)
      let student = null;
      if (selectedStudent) {
        if (typeof selectedStudent === 'object') {
          student = selectedStudent;
        }
      }

      let paid_by = sessionStorage.getItem("username") || "";
      const attempt_no = pending.attempt_no || 1;

      var enrolledby = "";
      if (userType === "student") {
        enrolledby = "Student";
      } else if (userType === "admin") {
        enrolledby = "Admin";
      } else {
        enrolledby = "Parent";
      }

      var enrollment_create_user_id = "";
      var enrollment_create_user_table_id = "";
      if (enrollType === "student") {
        enrollment_create_user_id = pending.create_user_id || sessionStorage.getItem("manage_user_id");
        enrollment_create_user_table_id = pending.create_user_table_id || sessionStorage.getItem("table_log_id");
      } else {
        enrollment_create_user_id = pending.create_user_id || sessionStorage.getItem("parent_group_id") || sessionStorage.getItem("manage_user_id");
        enrollment_create_user_table_id = pending.create_user_table_id || sessionStorage.getItem("parent_group_user_table_id") || sessionStorage.getItem("table_log_id");
      }

      // If student info is missing for parent flow, abort with a helpful error
      if (!student && userType !== 'student') {
        sweetStatusAlert("Error!", "Student information is missing. Please re-start the enrollment and select a student.", "error");
        setIsSpinnerLoading(false);
        return;
      }

      const payment_obj = {
        email: sessionStorage.getItem("email"),
        unit_amount: parseFloat(amount).toFixed(2),
        amount: parseFloat(amount).toFixed(2),
        credits: parseInt(no_of_credits),
        currency_type: currencySymbol || "",
        assessment_name: assess_name,
        node_mid: mid,
        assessment_id: assessment_id,
        enrollment_create_user_id: enrollment_create_user_id,
        enrollment_create_user_table_id: enrollment_create_user_table_id,
        user_id: userType === "student" ? session_id : (student && (student.user_id || student.stu_id)),
        user_table_id: userType === "student" ? table_log_id : (student && student.user_table_id),
        create_user_id: session_id,
        create_user_table_id: table_log_id,
        paid_by: paid_by,
        payment_method: "Online",
        reference_id: "N/A",
        form_list_id: 46,
        userType: userType,
        attempt_no: attempt_no,
        paper_status: 0,
        enrolled_by: enrolledby,
        enroll_user_table_id: userType === "student" ? 2 : (student && student.user_table_id),
        enroll_user_id: userType === "student" ? UserId : (student && (student.user_id || student.stu_id)),
        enrollType: enrollType,
        currencySymbol: currencySymbol,
        currencyId: currencyId,
        currencyName: currencyName
      };

      try {
        // Add popstate listener to handle browser back navigation
        window.addEventListener('popstate', handlePaymentCancelNavigation);

        // Initiate session and then remove pending saved data so it's not stale
        const res = await CombankService.getSessionIDAssessmentPurchase(JSON.stringify(payment_obj));
        sessionStorage.setItem("checkout_session_id", res.data.session.id);

        // Remove pending (we have initiated the payment flow)
        try { sessionStorage.removeItem('pendingAssessmentCreditEnrollment'); } catch (e) { /* ignore */ }

        setIsSpinnerLoading(false);
        loadCheckoutScript(res.data.session.id);
      } catch (error) {
        sweetStatusAlert("Error!", "An error occurred while getting session ID.", "error");
        setIsSpinnerLoading(false);
      }
    };

    const handlePaymentCancelNavigation = () => {
      // Clear any pending enrollment data if user navigates back/cancels
      try { sessionStorage.removeItem('pendingAssessmentCreditEnrollment'); } catch (e) { /* ignore */ }

      cancelCallback();
      window.removeEventListener('popstate', handlePaymentCancelNavigation);
    }

    const cancelCallback = () => {
      setIsSpinnerLoading(false);
      const script = document.querySelector("script[src*='checkout.min.js']");
      if (script) {
        document.head.removeChild(script);
      }
      sweetStatusAlert("Failed!", "Payment cancelled!", "info");
      history.goBack();
    };

    const errorCallback = (error) => {
      setIsSpinnerLoading(false);
      const script = document.querySelector("script[src*='checkout.min.js']");
      if (script) {
        document.head.removeChild(script);
      }
      sweetStatusAlert("Failed!", JSON.stringify(error), "error");
    };

    const successCallback = () => {
      setIsSpinnerLoading(false);
      const script = document.querySelector("script[src*='checkout.min.js']");
      if (script) {
        document.head.removeChild(script);
      }
      sweetStatusAlert("Success!", "Payment successful!", "success");
      history.goBack();
    };

    const loadCheckoutScript = (sessionID) => {
      const script = document.createElement("script");
      script.src = "https://cbcmpgs.gateway.mastercard.com/static/checkout/checkout.min.js";
      document.head.appendChild(script);
      script.onload = () => {
        window.Checkout.configure({
          session: {
            id: sessionID,
          },
        });

        window.Checkout.onComplete = successCallback;
        window.Checkout.onError = errorCallback;
        window.Checkout.onCancel = cancelCallback;

        if (window.Checkout) {
          const scriptTag = document.querySelector("script[src*='checkout.min.js']");
          if (scriptTag) {
            document.head.removeChild(scriptTag);
          }
          window.Checkout.showPaymentPage();
        }
      };
    };


  const handleCancel = () => {
    // sessionStorage.removeItem("payment_terms_accepted");
   
    history.goBack();
  };

  //   ***************************************  //                                       
  //   -----END Enrollment paper buy------         ////
  //  ****************************************  //   
  return (
    <div>
      <ContentWrapper>
        { isLoading && <LinearProgress />}
          {isSpinnerLoading && (
              <div style={{position: "fixed", top: 0, left: 0,  width: "100vw",height: "100vh", backgroundColor: "rgba(30, 30, 32, 0.2)",  zIndex: 9998,display: "flex",alignItems: "center",justifyContent: "center",}}>
            
                 <CircularProgress style={{ zIndex: 9999 }} />
              </div>
              )}

        <Card>
          <div
            className="term-container"
            style={{
              maxHeight: "100vh",
              overflowY: "auto",
              padding: "20px",
              border: "1px solid #ddd",
              scrollBehavior: "smooth",
            }}
          >
            {!isLoading && error && <div className="text-danger">{error}</div>}

            {!isLoading && !error && termsHtml && (
              <Container>
                <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
                
                
                {/* Confirmation controls */}
            <div style={{ marginTop: "30px",marginLeft:"70px", display: "flex", flexDirection: "column", gap: "12px" }}>
              
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="confirmRead"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="confirmRead">
                  I have read and accept the terms and conditions
                </label>
              </div>

              <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                <button className="btn btn-secondary" onClick={handleCancel}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleAccept}
                  disabled={!isChecked}
                >
                  Accept term
                </button>
              </div>
            </div>
              </Container>
            )}

            
          </div>
        </Card>
      </ContentWrapper>
      <Footer />
    </div>
  );
}

export default PaymentTermsCondition;
